export default {
  WEIGHT_FIELD: "weight_field",
  LENGTH_FIELD: "length_field",
  WIDTH_FIELD: "width_field",
  POSTFIX: "postfix",
};
